import React, { useState } from 'react';
import DashboardTabs from '@components/common/Dashboard/DashboardTabs';
import { Loading } from '@components/common';
import { getPrivatePulse5Dashboards, getPublicPulse5Dashboards } from '@src/api/dashboards';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import useGetSavedDashboardsList from './useGetSavedDashboardsList';
import DashboardTable from './components/DashboardTable';
import DashboardColumns from './components/DashboardColumns';
import DashboardTypesTabs from './components/DashboardTypesTabs';
import DataSourceSelection from './components/DataSourceSelection';
import {
  PRIVATE_SAVED_DASHBOARDS_KEY,
  PUBLIC_SAVED_DASHBOARDS_KEY,
  DataSourceMapping,
  tabList,
} from './utils';
import { Wrapper } from './styled';

const Content = () => {
  const [dataSource, setDataSource] = useState(() => {
    const productName = CURRENT_PRODUCT_MODE.toLocaleLowerCase();
    return DataSourceMapping[productName] ? productName : 'all';
  });
  const [activeTab, setActiveTab] = useState(PRIVATE_SAVED_DASHBOARDS_KEY);
  const columns = DashboardColumns[activeTab];

  const queryFunctions = {
    [PRIVATE_SAVED_DASHBOARDS_KEY]: getPrivatePulse5Dashboards,
    [PUBLIC_SAVED_DASHBOARDS_KEY]: getPublicPulse5Dashboards,
  };

  const { data, isLoading } = useGetSavedDashboardsList(
    activeTab,
    dataSource,
    queryFunctions[activeTab],
  );

  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };

  const handleDataSourceChange = (value: string) => {
    setDataSource(value);
  };

  return (
    <Wrapper>
      <DashboardTabs id="saved_dashboards" />
      <DashboardTypesTabs
        items={tabList}
        onChange={handleTabChange}
        tabBarExtraContent={
          <DataSourceSelection
            tabKey={activeTab}
            dataSource={dataSource}
            onChange={handleDataSourceChange}
          />
        }
      />
      {isLoading ? <Loading /> : <DashboardTable dashboards={data} columns={columns} />}
    </Wrapper>
  );
};

export default Content;
